import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueSimpleAlert from 'vue-simple-alert'
import './plugins'
import VueSpinners from 'vue-spinners'

import VueApexCharts from 'vue-apexcharts'

Vue.config.productionTip = false
export const bus = new Vue()

Vue.use(VueApexCharts)
Vue.use(require('vue-moment'))
Vue.use(VueSimpleAlert)
Vue.use(VueSpinners)

Vue.prototype.$mapsKey = 'AIzaSyClIFG-ONBwyXrn4_kaA4yMYHGpZD5EEko'
Vue.prototype.$useDevVariables = process.env.VUE_APP_USE_DEV_VARIABLES === 'true'

if (Vue.prototype.$useDevVariables === undefined) {
  Vue.prototype.$useDevVariables = false
}

Vue.component('apexchart', VueApexCharts)

new Vue({
  router,
  store,
  vuetify,
  mounted: () => document.dispatchEvent(new Event('x-app-rendered')),
  render: h => h(App),
}).$mount('#app')
